import { useState } from 'react';
import getResults from '../../Components/AppVocationStart/API/getResults';

const DataParserStartPage = () => {
  const [data, setData] = useState('');
  const [result, setResult] = useState(null);

  const handleParseData = () => {
    const parsed = typeof data === 'string' ? JSON.parse(data) : data;
    console.log({ parsed });
    const resultData = getResults(parsed);
    console.log({ resultData });
    setResult(resultData);
  };
  return (
    <div>
      <div>
        <h1>Data Results parser</h1>
      </div>
      <div>
        <h2>Voc Junior</h2>
        <div>
          <textarea
            value={data}
            onChange={e => setData(e.target.value)}
            cols={20}
            style={{ width: '80vw' }}
          />
        </div>
        <div>
          <button onClick={handleParseData}>Generar data</button>
        </div>
      </div>
      <h2>Result</h2>
      <div>
        <pre>{result && JSON.stringify(result, null, 2)}</pre>
      </div>
    </div>
  );
};

export default DataParserStartPage;
